import { useEffect, useState } from "react";
import { useSnapshot } from "valtio";
import { createUseStyles } from "react-jss";

import Lightbox from "./Lightbox";
import EventSelector from "./EventSelector";
import FloorplanItem from "./FloorplanItem";

import { fetchApi } from "../services/api";
import { currentAccount } from "../proxies";

const FloorplanSelector = ({ show, onSelect, onClose, tourInfo }) => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const { event } = useSnapshot(currentAccount);
  const classes = useStyles();

  useEffect(() => {
    setLoading(true);
    if (event)
      fetchApi(`/floors/list/${event}`).then(plans => {
        setPlans(plans);
        setLoading(false);
      });
  }, [event]);

  return (
    <Lightbox show={show} className={classes.lightbox} onClose={onClose}>
      <h3>Select Floor Plan</h3>
      <EventSelector light className={classes.selectors} tourInfo={tourInfo} />
      {plans.length === 0 && (
        <div>{loading ? "Loading..." : "No floorplans found"}</div>
      )}
      {plans.length > 0 && (
        <div className={classes.plans}>
          {plans.map(item => (
            <FloorplanItem
              key={item.id}
              name={item.name}
              url={item.url}
              onClick={() => onSelect(item)}
            />
          ))}
        </div>
      )}
    </Lightbox>
  );
};

const useStyles = createUseStyles(theme => ({
  selectors: {
    width: "100%",
    "margin-bottom": theme.spacing2,
  },
  lightbox: {
    width: "300px",
  },
  plans: {
    "max-height": "300px",
    "overflow-y": "auto",
  },
}));

export default FloorplanSelector;
